import styled from 'styled-components';

export const Sheet = styled.article<{ $width?: number; $shadow?: boolean }>`
  width: ${({ $width }) => ($width ? `${$width}px` : '720px')};
  max-width: 100%;
  margin: 0 auto;
  background: ${({ theme }) => theme.colors.bgPaper};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 4px;
  box-shadow: ${({ $shadow = true }) =>
    $shadow
      ? '0 12px 40px -12px rgb(28 25 23 / 0.14), 0 2px 6px -2px rgb(28 25 23 / 0.06)'
      : 'none'};
  padding: 64px 80px;
  font-family: ${({ theme }) => theme.fonts.heading};
  color: ${({ theme }) => theme.colors.textPrimary};
  position: relative;

  @media (max-width: 767.98px) {
    padding: 32px 24px;
  }
`;

export const MetaRow = styled.div`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 11px;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.textMuted};
  text-transform: uppercase;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};

  strong {
    color: ${({ theme }) => theme.colors.textSecondary};
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    margin-right: 6px;
  }
`;

export const MetaSpacer = styled.span`
  margin-left: auto;
`;

export const SheetTitle = styled.h1`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-size: 32px;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 28px;
  text-align: center;
  text-transform: uppercase;
  font-variant: small-caps;
`;

export const Body = styled.div`
  font-size: 17px;
  line-height: 1.75;
  max-width: 64ch;
  margin: 0 auto;
  font-feature-settings: 'liga', 'kern', 'onum';
  white-space: pre-wrap;

  p {
    margin: 0 0 1em;
  }
`;
